module.exports = __webpack_public_path__ + "static/media/celu.0b4f6f15.png";